import { createContext, useContext } from 'react';
import { TechnicalPause } from '@lib/hooks/useTechnicalPause';

export type TechnicalPauseContextValue = {
  activeTechnicalPause: TechnicalPause | null;
  upcomingTechnicalPause: TechnicalPause | null;
  loading: boolean;
  fetched: boolean;
};

const TechnicalPauseContext = createContext<TechnicalPauseContextValue>({
  activeTechnicalPause: null,
  upcomingTechnicalPause: null,
  loading: false,
  fetched: false,
});

export const useTechnicalPauseContext = () => useContext(TechnicalPauseContext);
export default TechnicalPauseContext;
